import { Injectable } from '@angular/core';
import { DataListModel } from '../../models/data-list-model';
import { Observable } from 'rxjs';
import { Product } from '../../dto/product';
import { HttpParams, HttpClient } from '@angular/common/http';
import { CrudService } from '../../services';
import { Upload } from '../../dto/upload';
import { Voucher } from '../../dto/voucher';

@Injectable({
  providedIn: 'root'
})
export class VouchersService implements CrudService<Voucher> {
  readonly apiPath = 'voucher-orders/';
  public id: number;
  constructor(
    private http: HttpClient,
  ) { }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string
  ): Observable<DataListModel<Voucher>> {
    const params = new HttpParams()
      .set('page',          pageIndex.toString())
      .set('pageSize',      pageSize.toString())
      .set('filterString',  filterString)
      .set('sortField',     sortField)
      .set('sortDirection', sortDirection);
    return this.http.get(`${this.apiPath}${this.id}/vouchers`, { params }) as Observable<DataListModel<Voucher>>;
  }

  get(id: number): Observable<Voucher> {
    throw new Error('Method not implemented.');
  }

  add(item: Voucher): Observable<Object> {
    return this.http.post(this.apiPath, item);
  }

  update(id: any, item: Voucher): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  delete(id: number): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  restore(id: number): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  deleteMany(idList: any[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  restoreMany(list: any[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }
}
